import crudAction from './actions'

export default {
  name: 'fiscalDocumentation',
  namespace: 'fiscal_documentation',
  methods: [
    ...crudAction,
  ]
}